<template>
        <nav class="navbar navbar-expand-md  fixed-top ">
            <div class="container">

                <a href="./"><img src="@/assets/images/yslogo.png" class="header-logo img-fluid"></a>

            <button class="navbar-toggler custom-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation" >
                <span class="navbar-toggler-icon "></span>
            </button>

            <div class="collapse navbar-collapse" id="navbarCollapse">
                <ul class="navbar-nav mr-auto">
                    <li class="nav-item active">
                        <router-link to="/" class="nav-link">Home</router-link>
                    </li>

                    <li class="nav-item">

                        <router-link to="/over-yoursource" class="nav-link">Over Yoursource</router-link>
                    </li>

                    <li class="nav-item">

                        <router-link to="/veel-gestelde-vragen" class="nav-link">Faq</router-link>
                    </li>
                    <li class="nav-item">

                        <router-link to="/support" class="nav-link">Support</router-link>
                    </li>




                    <li class="nav-item">

                        <router-link to="/contact" class="nav-link">Contact</router-link>
                    </li>

                </ul>

            </div>
            </div>
        </nav>
</template>

<script>

    export default {

    }
</script>